import React, { useContext, useEffect, useState } from 'react';
import './ShipmentListCardOptions.scss';
import { Button, Popover, message } from 'antd';
import { markShipmentComplete, starShipment } from '../../../services/shipments';
import { getIcon } from '../../../utils/images';
import LabelModal from '../../Modals/LabelModal/LabelModal';
import { useNavigate } from 'react-router-dom';
import { getShareUrl } from '../../../services/user';
import { useCopyToClipboard } from 'usehooks-ts';
import UploadModal from '../../Modals/UploadModal/UploadModal';
import ConfirmationModal from '../../Modals/ConfirmationModal/ConfirmationModal';

const Options = ({ shipment, refetch, close, onShowNowlunForm, readableOnly }) => {
  const navigate = useNavigate();
  const [_, copy] = useCopyToClipboard();

  const [isLabelModalOpen, setIsLabelModalOpen] = useState(false);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [confirmationAction, setConfirmationAction] = useState(null);


  const handleCancel = () => {
    setIsLabelModalOpen(false);
    setIsUploadModalOpen(false);
    setIsConfirmationModalOpen(false);
    refetch();
  };

  async function handleStarOnClicked() {
    await starShipment(shipment.id);
    refetch();
    close();
  }

  function handleManageLabelsClicked() {
    setIsLabelModalOpen(true);
    close();
  }

  async function handleShareShipment() {
    const resp = await getShareUrl({ shipment_id: shipment.id });
    copy(`${process.env.REACT_APP_ROOT_HOST}${resp.data.url}`);
    message.success('Share URL copied to clipboard');
  }

  function handleUploadDocument() {
    setIsUploadModalOpen(true);
    close();
  }

  function handleShippingDeclarationClicked() {
    navigate(`/shipments/${shipment.id}/shipping_declaration`);
    close();
  }

  function handleFinalShippingInstructionClicked() {
    navigate(`/shipments/${shipment.id}/final_shipping_instruction`);
    close();
  }

  function handleEditShipment() {
    onShowNowlunForm(shipment);
    close();
  }

  function handleMarkCompleteClicked() {
    setConfirmationAction("complete");
    setIsConfirmationModalOpen(true);
    close();
  }

  function handleCancelClicked() {
    setConfirmationAction("cancel");
    setIsConfirmationModalOpen(true);
    close();
  }

  return (
    <div className="ShipmentListCardOptions">
      <div className="option-wrapper">
        <div className="option-icon">
          <img src={getIcon('star-shipment')} />
        </div>
        <div className="option-text">
          <Button onClick={handleStarOnClicked}>{shipment.star ? 'Unstar Shipment' : 'Star Shipment'}</Button>
        </div>
      </div>

      <div className="option-wrapper">
        <div className="option-icon">
          <img src={getIcon('label')} />
        </div>
        <div className="option-text">
          <Button onClick={handleManageLabelsClicked}>Manage Labels</Button>
        </div>
      </div>


      <div className="option-wrapper">
        <div className="option-icon">
          <img src={getIcon('share-shipment')} />
        </div>
        <div className="option-text">
          <Button onClick={handleShareShipment}>Share Shipment</Button>
        </div>
      </div>

      <div className="option-wrapper">
        <div className="option-icon">
          <img src={getIcon('upload-document')} />
        </div>
        <div className="option-text">
          <Button onClick={handleUploadDocument}>Upload Documents</Button>
        </div>
      </div>

      {
        !readableOnly && (
          <div className="option-wrapper">
            <div className="option-icon">
              <img src={getIcon('remarks')} />
            </div>
            <div className="option-text">
              <Button onClick={handleEditShipment}>Edit Shipment</Button>
            </div>
          </div>
        )
      }
      {
        !readableOnly && (
          <div className="option-wrapper">
            <div className="option-icon">
              <img src={getIcon('complete-shipment')} />
            </div>
            <div className="option-text">
              <Button onClick={handleMarkCompleteClicked}>Mark Shipment Complete</Button>
            </div>
          </div>
        )
      }

      {
        !readableOnly && (
          <div className="option-wrapper">
            <div className="option-icon">
              <img src={getIcon('complete-shipment')} />
            </div>
            <div className="option-text">
              <Button onClick={handleCancelClicked}>Cancel Shipment</Button>
            </div>
          </div>
        )
      }

      {
        shipment.show_shipping_declaration && (
          <div className="option-wrapper">
            <div className="option-icon">
              <img src={getIcon('shipping-instruction')} />
            </div>
            <div className="option-text">
              <Button onClick={handleShippingDeclarationClicked}>Shipping Declaration</Button>
            </div>
          </div>
        )
      }

      {
        shipment.show_final_shipping_instruction && (
          <div className="option-wrapper">
            <div className="option-icon">
              <img src={getIcon('shipping-instruction')} />
            </div>
            <div className="option-text">
              <Button onClick={handleFinalShippingInstructionClicked}>Final Shipping Instruction</Button>
            </div>
          </div>
        )
      }

      <LabelModal shipment={shipment} isOpen={isLabelModalOpen} handleCancel={handleCancel} />
      <UploadModal shipment={shipment} isOpen={isUploadModalOpen} handleCancel={handleCancel} />
      <ConfirmationModal shipment={shipment} isOpen={isConfirmationModalOpen} handleCancel={handleCancel} action={confirmationAction}/>
    </div>
  );
};

const ShipmentListCardOptions = (
  {
    shipment,
    refetch,
    shipmentOptionsOpened,
    setShipmentOptionsOpened,
    onShowNowlunForm,
    readableOnly,
  },
) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(shipment.id == shipmentOptionsOpened);
  }, [shipmentOptionsOpened]);

  const toggleOpen = () => {
    show ? setShipmentOptionsOpened(null) : setShipmentOptionsOpened(shipment.id);
    setShow(!show);
  };

  const close = () => {
    setShow(false);
  };

  return (
    (
      <Popover
        content={<Options shipment={shipment} refetch={refetch} close={close}
                          onShowNowlunForm={onShowNowlunForm} readableOnly={readableOnly} />}
        trigger="click"
        arrow={false}
        open={show}
        placement="bottomRight">
        <Button id="options" onClick={toggleOpen}></Button>
      </Popover>
    )
  );
};

export default ShipmentListCardOptions;
